import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripoService {

  constructor(private http: HttpClient) { }

  public getConfig(token: string, emailId: string, userId: string, username: string): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
    });
    return this.http.get('https://plugins.stripo.email/api/v1/plugins/config', { headers }).pipe(
      tap(response => {
        console.log('Stripo Config:', response);
      })
    );
  }
  
  public getCustomBlocks(token: string, key: string, emailId: string, userId: string, username: string): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0'
    });
    
    // key comes from stripoUserKey e.g. "email_${UserId}"
    // URL content: key=?, grouping=CATEGORY, withTags=true
    const url = `https://plugins.stripo.email/api/v1/customblocks/v4/modules?key=${encodeURIComponent(key)}&grouping=CATEGORY&withTags=true`;

    return this.http.get(url, { headers }).pipe(
      tap(response => {
        console.log('Stripo Custom Blocks:', response);
      })
    );
  }

  public generateScreenshot(token: string, emailId: string, userId: string, username: string, payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
      'Content-Type': 'application/json'
    });

    const url = 'https://plugins.stripo.email/api/v1/documents/v3/screenshots/link';

    return this.http.post(url, payload, { headers }).pipe(
      tap(response => {
        console.log('Stripo Screenshot Generated:', response);
      })
    );
  }
  
  public saveCustomBlock(token: string, emailId: string, userId: string, username: string, payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
      'Content-Type': 'application/json'
    });

    const url = 'https://plugins.stripo.email/api/v1/customblocks/v3/blocks';

    return this.http.post(url, payload, { headers }).pipe(
      tap(response => {
        console.log('Stripo Custom Block Saved:', response);
      })
    );
  }

  public updateCustomBlock(token: string, emailId: string, userId: string, username: string, moduleId: any, payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
      'Content-Type': 'application/json'
    });

    const url = `https://plugins.stripo.email/api/v1/customblocks/v3/blocks/${moduleId}`;

    return this.http.patch(url, payload, { headers }).pipe(
      tap(response => {
        console.log('Stripo Custom Block Updated:', response);
      })
    );
  }

  public getCustomBlockById(token: string, emailId: string, userId: string, username: string, moduleId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
    });

    const url = `https://plugins.stripo.email/api/v1/customblocks/v3/blocks/${moduleId}`;
    return this.http.get(url, { headers }).pipe(
      tap(response => {
        console.log('Stripo Custom Block Loaded:', response);
      }),
    );
  }

  public getModuleById(token: string, emailId: string, userId: string, username: string, moduleId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
    });

    const url = `https://plugins.stripo.email/api/v1/customblocks/v4/module/${moduleId}`;
    return this.http.get(url, { headers });
  }

  public getModuleConfig(token: string, emailId: string, userId: string, username: string): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
    });

    return this.http.get('https://plugins.stripo.email/api/v1/plugins/config', { headers }).pipe(
      tap(response => {
        console.log('Stripo Module Config:', response);
      }),
    );
  }
  
  public getAuthToken(): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(
      environment.backendUrl + '/api/stripo/auth/',
      {}
    );
  }

  public getMaxModules(token: string, key: string, emailId: string, userId: string, username: string, tagId?: any): Observable<any> {
    let url = `https://plugins.stripo.email/api/v1/customblocks/v4/modules?key=${encodeURIComponent(key)}`;
    if (tagId) {
      url += `&tags=${tagId}`;
    }

    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0'
    });

    return this.http.get(url, { headers })
  }

  public deleteCustomBlock(token: string, emailId: string, userId: string, username: string, moduleId: any, key: string): Observable<any> {
    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0',
    });

    const url = `https://plugins.stripo.email/api/v1/customblocks/v3/blocks/${moduleId}?key=${encodeURIComponent(key)}`;

    return this.http.delete(url, { headers }).pipe(
      tap(response => {
        console.log('Stripo Custom Block Deleted:', response);
      })
    );
  }

  public getMoreModules(
    token: string, 
    key: string, 
    emailId: string, 
    userId: string, 
    username: string, 
    limit: number,
    offset: number = 0,
    tagId?: any
  ): Observable<any> {
    let url = `https://plugins.stripo.email/api/v1/customblocks/v4/modules/more?key=${encodeURIComponent(key)}&limit=${limit}&offset=${offset}`;
    if (tagId) {
      url += `&tags=${tagId}`;
    }

    const headers = new HttpHeaders({
      'Es-Plugin-Auth': `Bearer ${token}`,
      'Es-Plugin-Ui-Data': encodeURI(JSON.stringify({ emailId, UserId: userId, username: username })),
      'Es-Plugin-Locale': 'fr',
      'Es-Plugin-Ui-Version': '2.27.0'
    });

    return this.http.get(url, { headers });
  }
}
